import { Button } from "@mui/material";
import { ReactElement } from "react";
import { Link as RouterLink } from "react-router-dom";
import { COLORS } from "../../constants";

export type TvButtonProps = {
    text: string,
    /** External URL or mailto: */
    link?: string,
    /** Internal route */
    to?: string,
    icon?: ReactElement,
    variant?: 'primary' | 'outline',
    /** Background the button sits on */
    tone?: 'dark' | 'light',
    size?: 'small' | 'medium' | 'large',
    onClick?: () => void,
    type?: 'button' | 'submit',
    disabled?: boolean,
    fullWidth?: boolean,
}

function TvButton({ text, icon, link, to, variant = 'primary', tone = 'light', size = 'medium', onClick, type, disabled, fullWidth }: TvButtonProps) {
    const isExternal = !!link && /^https?:/.test(link)

    const sx = variant === 'primary'
        ? {
            backgroundColor: COLORS.accent,
            color: COLORS.black,
            '&:hover': { backgroundColor: COLORS.accentHover },
        }
        : {
            border: `1.5px solid ${tone === 'dark' ? 'rgba(255,255,255,0.45)' : COLORS.black}`,
            color: tone === 'dark' ? COLORS.white : COLORS.black,
            '&:hover': {
                borderColor: COLORS.accent,
                backgroundColor: tone === 'dark' ? 'rgba(32,197,245,0.08)' : 'rgba(11,13,16,0.04)',
            },
        }

    const linkProps = to
        ? { component: RouterLink, to }
        : link
            ? { href: link, ...(isExternal ? { target: '_blank', rel: 'noreferrer' } : {}) }
            : {}

    return (
        <Button
            {...linkProps}
            onClick={onClick}
            type={type}
            disabled={disabled}
            fullWidth={fullWidth}
            size={size}
            endIcon={icon}
            sx={{ ...sx, whiteSpace: 'nowrap', ...(size === 'large' ? { px: 3.5, py: 1.6, fontSize: '1.05rem' } : {}) }}
        >
            {text}
        </Button>
    );
}

export default TvButton;
